import axios from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function generateContract (pFormdata) {
    const URI = `${BASE_URL}/api/generate-contract`
    const responseType = 'blob'
    return axios.post(URI, pFormdata, { headers, responseType })
}

export { generateContract }